const SOURCE_CITATION_LABEL_RE = /\[S(\d+)(?:\s+[^\]\n]{0,200})?\]/g;

export const collectCitedSourceLabels = (markdown: string) => {
  const labels = new Set<string>();
  for (const match of markdown.matchAll(SOURCE_CITATION_LABEL_RE)) {
    labels.add(`S${Number(match[1])}`);
  }
  return labels;
};
